import React, { useState } from 'react';
import { Input, Button, Space } from 'antd';

export const MessageEditor = ({ message, onSave, onCancel }) => {
  const [editedText, setEditedText] = useState(message.data);

  const handleSave = () => {
    if (editedText.trim()) {
      onSave(message.id, editedText);
    }
  };

  return (
    <div style={{ width: '100%' }}>
      <Input.TextArea
        value={editedText}
        onChange={(e) => setEditedText(e.target.value)}
        autoSize={{ minRows: 1, maxRows: 6 }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSave();
          }
        }}
      />
      <Space style={{ marginTop: '8px', float: 'right' }}>
        <Button onClick={onCancel} size="small">
          Cancelar
        </Button>
        <Button type="primary" onClick={handleSave} size="small">
          Salvar
        </Button>
      </Space>
    </div>
  );
};
